export var REMAX_ROOT_BACKUP = '$$REMAX_ROOT_BACKUP';
export var REMAX_METHOD = '$$REMAX_METHOD';
export var TYPE_TEXT = 'plain-text';
